// const EventEmitter = require('events');
import { setAnimationControllerLoading } from '../../../components/animations/AnimationController.svelte';
// import EventEmitter from "events";
class EventEmitter {
    events = {};
    on(event, listener) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(listener);
    }
    off(event, listener) {
        if (!this.events[event]) {
            return;
        }
        this.events[event] = this.events[event].filter((l) => l !== listener);
    }
    clear() {
        this.events = {};
    }
    emit(event, ...args) {
        if (!this.events[event]) {
            return;
        }
        this.events[event].forEach((l) => l(...args));
    }
}
export var VideoReadyState;
(function (VideoReadyState) {
    VideoReadyState[VideoReadyState["HAVE_NOTHING"] = 0] = "HAVE_NOTHING";
    VideoReadyState[VideoReadyState["HAVE_METADATA"] = 1] = "HAVE_METADATA";
    VideoReadyState[VideoReadyState["HAVE_CURRENT_DATA"] = 2] = "HAVE_CURRENT_DATA";
    VideoReadyState[VideoReadyState["HAVE_FUTURE_DATA"] = 3] = "HAVE_FUTURE_DATA";
    VideoReadyState[VideoReadyState["HAVE_ENOUGH_DATA"] = 4] = "HAVE_ENOUGH_DATA";
})(VideoReadyState || (VideoReadyState = {}));
export var AnimationPlayerEvents;
(function (AnimationPlayerEvents) {
    AnimationPlayerEvents["BUFFERING"] = "buffering";
    AnimationPlayerEvents["PLAY_REQUESTED"] = "play-requested";
    AnimationPlayerEvents["PAUSE_REQUESTED"] = "pause-requested";
    AnimationPlayerEvents["ERROR"] = "error";
    AnimationPlayerEvents["PLAY_READY"] = "play-ready";
    AnimationPlayerEvents["PLAYING"] = "playing";
    AnimationPlayerEvents["STOP_REQUEESTED"] = "stop-requested";
    AnimationPlayerEvents["FOR_PRODUCTION"] = "for-production";
    AnimationPlayerEvents["ENDED"] = "ended";
    AnimationPlayerEvents["SEEKED"] = "seeked";
})(AnimationPlayerEvents || (AnimationPlayerEvents = {}));
export var AnimationPlayerState;
(function (AnimationPlayerState) {
    AnimationPlayerState["PLAYING"] = "playing";
    AnimationPlayerState["PAUSED"] = "paused";
    AnimationPlayerState["BUFFERING"] = "buffering";
    AnimationPlayerState["PLAY_REQUESTED"] = "play-requested";
    AnimationPlayerState["PAUSE_REQUESTED"] = "pause-requested";
    AnimationPlayerState["STOPPED"] = "stopped";
})(AnimationPlayerState || (AnimationPlayerState = {}));
export class NoDataAttachedError extends Error {
    constructor() {
        super('No data attached');
    }
}
const pauseEvents = ['abort', 'emptied', 'error', 'stalled', 'suspend', 'pause', 'waiting'];
const playEvents = [
    'canplay',
    'canplaythrough',
    'durationchange',
    'loadeddata',
    'loadedmetadata',
    'loadstart',
    'play',
    'playing',
    'progress'
];
/**
 * AnimationPlayer class
 *
 * This animation player depends on a central video element (which in our case would be the main sermon clip). It controls the playback of the video element and any other animations that are added to it.
 */
export class AnimationTimelinePlayer {
    timelines = [];
    animationPlayerState = AnimationPlayerState.STOPPED;
    events = new EventEmitter();
    playRequested;
    videoNode;
    buffering = false;
    productionRunthrough = false;
    cachedPauseEvents = [];
    cachedPlayEvents = [];
    state = AnimationPlayerState.STOPPED;
    shouldRecord = false;
    fireOnEnded = true;
    nextTick;
    lastTick = 0;
    productionEnvironment = {
        lastTimeUpdate: 0,
        started: false,
        intervalCheckingFunction: null
    };
    internalNextTickAwaitingCallback = null;
    internalEvents = []; // These are internal events that play on timeUpdate do not use this for any other purpose please.
    constructor() {
        this.initializeVisibilityChange();
    }
    initializeVisibilityChange() {
        document.addEventListener('visibilitychange', () => {
            if (this.productionRunthrough)
                return;
            console.warn('Visibility changed...');
            if (this.animationPlayerState !== AnimationPlayerState.PLAYING)
                return;
            console.log('Visibility changed...', document.hidden);
            if (document.hidden) {
                this.pause();
            }
            else {
                this.play();
            }
        });
    }
    get dataAttached() {
        return this.timelines.length > 0 && this.videoNode ? true : false;
    }
    setProductionRunthrough(value) {
        this.productionRunthrough = value;
        this.events.emit(AnimationPlayerEvents.FOR_PRODUCTION, value);
    }
    /**
     * This function will be called for most of the public functions that can be called from the outside. Its purpose is to ensure that the data required for the function to run is attached to the class
     */
    _guardAttachedData() {
        if (!this.dataAttached) {
            throw new NoDataAttachedError();
        }
    }
    sanitizeOldVideoNode(newNode) {
        console.log('Sanitizing old video node...');
        if (this.videoNode == newNode) {
            console.warn('[Warning] New Video node is the same as the old one. No need to sanitize');
            console.trace();
            return;
        }
        // Remove all event listeners
        this.videoNode.onplay = null;
        this.videoNode.onpause = null;
        this.videoNode.onloadeddata = null;
        this.videoNode.oncanplay = null;
        this.videoNode.onwaiting = null;
        this.videoNode.onended = null;
        this.cleanVideoData();
    }
    /**
     * This attach function is pivotal to the use of this class, every other function call does not
     */
    attachVideoNode(node) {
        if (this.videoNode)
            this.sanitizeOldVideoNode(node); // Just incase the template is being refreshd
        this.videoNode = node;
        this.videoNode.loop = false;
        this.prepareVideoData();
        this.setupEvents();
        if (this.videoNode.readyState > 0) {
            setAnimationControllerLoading(false);
        }
    }
    seek(percentage) {
        this.setTimelineTo(percentage);
        const time = this.videoNode.duration * percentage;
        this.videoNode.currentTime = time;
        this.events.emit(AnimationPlayerEvents.SEEKED, time);
    }
    hasPending() { }
    onVideoPlay() {
        // alert('Video play');
        this.events.emit(AnimationPlayerEvents.PLAYING);
        if (this.playRequested) {
            this.loopThroughTimelinesAndAlter(true);
            this.nextTick = () => {
                console.log('Next tick called...');
                this.loopThroughTimelinesToSeek();
            };
        }
        this.detectProductionEnvironmentMonitoring();
    }
    onVideoPause() {
        // alert('Video paused...')
        this.loopThroughTimelinesAndAlter(false);
    }
    onVideoLoadedData() {
        console.log('Video loaded data...');
    }
    onVideoCanPlay() {
        this.events.emit(AnimationPlayerEvents.PLAY_READY);
        if (this.buffering) {
            this.setBuffering(false);
            this.loopThroughTimelinesAndAlter(true);
        }
    }
    onVideoWaitingForData() {
        if (this.playRequested) {
            this.setBuffering(true);
            this.loopThroughTimelinesAndAlter(false);
        }
    }
    onTimeUpdate(e) {
        if (this.videoNode.currentTime === this.videoNode.duration) {
            console.log('Video ended detected from onTimeUpdate...');
            if (this.fireOnEnded)
                this.onVideoEnded();
            else
                console.log('Video event already fired, skipping.');
        }
        if (this.nextTick !== null) {
            if (!(this.videoNode.currentTime - this.lastTick > 0))
                return; // did not move forward
            console.log(e, this.videoNode.currentTime, this.videoNode.duration);
            try {
                this.nextTick();
            }
            catch (err) {
                console.warn('Error in nextTick', err);
            }
            this.nextTick = null;
        }
        this.lastTick = this.videoNode.currentTime;
    }
    onVideoEnded() {
        this.fireOnEnded = false;
        console.log('Video ended.');
        this.events.emit(AnimationPlayerEvents.ENDED);
        window.playingStatus = 'pause';
        if (this.productionRunthrough) {
            console.log('Stopping recording...');
            try {
                if (window.electronAPI && this.shouldRecord) {
                    window.electronAPI.stopRecording();
                }
            }
            catch (err) {
                console.warn('[electron api error]');
            }
        }
    }
    resetTimelinesToStart() {
        this.timelines.forEach(timeline => {
            timeline.seek(1);
        });
    }
    setupEvents() {
        const c = this;
        this.videoNode.onplay = () => this.onVideoPlay();
        this.videoNode.onpause = () => this.onVideoPause();
        this.videoNode.onloadeddata = () => this.onVideoLoadedData();
        this.videoNode.oncanplay = () => this.onVideoCanPlay();
        this.videoNode.onwaiting = () => this.onVideoWaitingForData();
        this.videoNode.onended = () => this.onVideoEnded();
        this.videoNode.ontimeupdate = e => this.onTimeUpdate(e);
    }
    /**
     * We have identified that the video node does not always fire the onended event.
     * Apparantly this is because the video (source) is not always encoded properly.
     * We have taken a look at the internal workings of how we create the video (the short cut on our end), but there is no way to fix this definitively for 100% of the cases. Because of encoding errors in the original source videos.
     *
     * We have implemented a fallback mechanism that will stop the recording if the onended event is not fired after a certain amount of time after the last detected timeupdate event.
     *
     * (timeupdate event still fires)
     */
    detectProductionEnvironmentMonitoring() {
        if (this.productionRunthrough) {
            if (this.videoNode.duration == null) {
                this.startProductionEnvironmentMonitoring();
            }
        }
    }
    startProductionEnvironmentMonitoring() {
        this.productionEnvironment.intervalCheckingFunction = setInterval(() => {
            if (this.productionEnvironment.lastTimeUpdate !== this.lastTick || this.productionEnvironment.started === false) {
                this.productionEnvironment.lastTimeUpdate = this.lastTick;
                this.productionEnvironment.started = true;
                return;
            }
            else {
                if (this.productionEnvironment.intervalCheckingFunction !== null) {
                    clearInterval(this.productionEnvironment.intervalCheckingFunction);
                    this.productionEnvironment.intervalCheckingFunction = null;
                    if (window.electronAPI) {
                        console.warn('[Triggering electron api manually] Video node duration is null');
                        window.electronAPI.stopRecording();
                    }
                    else {
                        console.warn('[electron api error]');
                    }
                }
            }
        }, 150);
    }
    async prepareVideoData() {
        const t = this; // Event emitter dont seem to know the context of the class
        pauseEvents.forEach(event => {
            const e = () => {
                this.events.emit('pause', event);
            };
            this.videoNode.addEventListener(event, e);
            this.cachedPauseEvents.push(e);
        });
        playEvents.forEach(event => {
            const e = () => {
                this.events.emit('play', event);
            };
            this.videoNode.addEventListener(event, e);
            this.cachedPlayEvents.push(e);
        });
    }
    cleanVideoData() {
        pauseEvents.forEach((event, index) => {
            this.cachedPauseEvents.forEach(e => this.videoNode.removeEventListener(event, e));
        });
        playEvents.forEach((event, index) => {
            this.cachedPlayEvents.forEach(e => this.videoNode.removeEventListener(event, e));
        });
    }
    setBuffering(buffer) {
        this.buffering = buffer;
        if (this.buffering)
            this.events.emit(AnimationPlayerEvents.BUFFERING, buffer);
    }
    async playVideo() {
        this.animationPlayerState = AnimationPlayerState.PLAYING;
        this.videoNode.play();
    }
    async pauseVideo() {
        this.animationPlayerState = AnimationPlayerState.PAUSED;
        this.videoNode.pause();
    }
    getTimelineProgress() {
        // for(let i = 0; i < this.timelines.length; i++) {
        //     const timeline = this.timelines[i];
        //     return timeline.progress;
        // }
        return this.videoNode.currentTime / this.videoNode.duration;
    }
    async loopThroughTimelinesToSeek() {
        const time = this.videoNode.currentTime;
        this.timelines.forEach(timeline => {
            timeline.seek(time * 1000);
        });
    }
    async loopThroughTimelinesAndAlter(play = false) {
        // If play is true it will play the timelines and if it is puase, it will pause it
        const time = this.videoNode.currentTime;
        this.timelines.forEach(timeline => {
            if (play) {
                timeline.seek(time * 1000);
                timeline.play();
                // if(this.productionRunthrough) {
                //     try {
                //         if(window.electronAPI) window.electronAPI.startRecording();
                //     } catch(err) {
                //         // Do nothing
                //     }
                // }
            }
            else
                timeline.pause();
        });
        if (play) {
            this.fireOnEnded = true;
            window.playingStatus = 'play';
            this.animationPlayerState = AnimationPlayerState.PLAYING;
            this.events.emit(AnimationPlayerEvents.PLAYING);
        }
        else {
            this.fireOnEnded = false;
            window.playingStatus = 'pause';
            this.animationPlayerState = AnimationPlayerState.PAUSED;
        }
    }
    clearEvents() {
        this.events.clear();
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    resetState() {
        this.animationPlayerState = AnimationPlayerState.STOPPED;
        this.playRequested = false;
    }
    setTimelineTo(percentage) {
        this.timelines.forEach(timeline => {
            const time = timeline.duration * percentage;
            timeline.seek(time);
        });
    }
    async play() {
        this._guardAttachedData();
        const currentProgress = this.getTimelineProgress();
        if (currentProgress === 100) {
            console.log('Resetting timelines to start...');
            this.resetTimelinesToStart();
        }
        this.events.emit(AnimationPlayerEvents.PLAY_REQUESTED);
        this.playRequested = true;
        this.playVideo();
    }
    async playProduction() {
        console.log('Playing production...');
        this.events.emit(AnimationPlayerEvents.PLAY_REQUESTED);
        this._guardAttachedData();
        this.playRequested = true;
        this.playVideo();
    }
    async pause() {
        this.events.emit(AnimationPlayerEvents.PAUSE_REQUESTED);
        this._guardAttachedData();
        this.playRequested = false;
        this.pauseVideo();
    }
    async stop() {
        this.pause();
        this.events.emit(AnimationPlayerEvents.STOP_REQUEESTED);
        this.resetState();
    }
    addAnimationTimeline(animeJsTimeline) {
        this.timelines.push(animeJsTimeline);
    }
    setAnimationTimeline(timeline) {
        this.timelines = [timeline];
    }
}
